import React, { useEffect, useState, useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useLanguage } from '../../contexts/LanguageContext';
import { useGetAvailableWarrantyTypesQuery } from '../../api/endpoints/warrantyClaims';
import { formatDateForApi } from '../../utils/dateUtils';

const SubWarrantyTypeDropdown = ({ value, onChange, className, placeholder, disabled = false, chassisNo, claimDate, kmInformation }) => {
    const { getCurrentLanguageId } = useLanguage();
    const [selectedWarrantyType, setSelectedWarrantyType] = useState(null);

    const shouldFetchData = Boolean(chassisNo && claimDate && kmInformation !== undefined);

    const { data: warrantyTypesData, isLoading } = useGetAvailableWarrantyTypesQuery(
        {
            ChassisNo: chassisNo,
            ClaimDate: formatDateForApi(claimDate),
            KmInformation: kmInformation,
            LanguageId: getCurrentLanguageId()
        },
        {
            skip: !shouldFetchData
        }
    );

    const warrantyTypeList = warrantyTypesData?.subWarrantyTypes || [];

    const warrantyTypeOptions = useMemo(() => {
        return warrantyTypeList.map((type) => ({
            id: type.id,
            code: type.code,
            text: type.translatedText,
            displayValue: type.translatedText
        }));
    }, [warrantyTypeList]);

    const handleSelectionChange = (e) => {
        setSelectedWarrantyType(e.value);
        onChange(e.value ? e.value.code : '');
    };

    useEffect(() => {
        if (warrantyTypeOptions.length > 0 && value) {
            const found = warrantyTypeOptions.find((option) => option.code == value);
            if (found) {
                setSelectedWarrantyType(found);
            }
        } else if (!value) {
            setSelectedWarrantyType(null);
        }
    }, [value, warrantyTypeOptions]);

    return (
        <Dropdown
            value={selectedWarrantyType}
            options={warrantyTypeOptions}
            onChange={handleSelectionChange}
            optionLabel="displayValue"
            showClear
            className={className}
            placeholder={placeholder || 'Alt Garanti Tipi seçiniz'}
            loading={isLoading}
            disabled={disabled}
            itemTemplate={(option) => <div>{option.text}</div>}
        />
    );
};

export default SubWarrantyTypeDropdown;
